import { render, staticRenderFns } from "./EditFooter.vue?vue&type=template&id=1412499d&scoped=true&"
import script from "./EditFooter.vue?vue&type=script&lang=js&"
export * from "./EditFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1412499d",
  null
  
)

export default component.exports